export interface Review {
  id: string;
  reviewer: string;
  avatar: string;
  rating: number;
  text: string;
  property: string;
  date: string;
  location: string;
}

export const reviews: Review[] = [
  {
    id: '1',
    reviewer: 'Alexandra Bennett',
    avatar: 'https://public.readdy.ai/ai/img_res/c9df87e23426650a2e35f365dbb823df.jpg',
    rating: 5,
    text: 'MyAbode made finding our dream home an absolute pleasure. The search tools are incredibly intuitive, and our agent Sarah was phenomenal throughout the entire process. We found our perfect villa in just two weeks!',
    property: 'Modern Luxury Villa with Pool',
    date: 'March 2026',
    location: 'Beverly Hills, CA',
  },
  {
    id: '2',
    reviewer: 'Marcus Johnson',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20man%20headshot%2C%20confident%20smile%2C%20business%20casual%2C%20light%20background%2C%2040s&width=80&height=80&seq=rev2&orientation=squarish',
    rating: 5,
    text: 'The booking viewing feature saved me so much time. I could schedule multiple viewings in one afternoon and the calendar system worked flawlessly. Ended up buying a penthouse I never would have found otherwise.',
    property: 'Downtown Penthouse with City Views',
    date: 'February 2026',
    location: 'Manhattan, NY',
  },
  {
    id: '3',
    reviewer: 'Sophie Williams',
    avatar: 'https://readdy.ai/api/search-image?query=young%20professional%20woman%20headshot%2C%20bright%20smile%2C%20modern%20style%2C%20clean%20background&width=80&height=80&seq=rev3&orientation=squarish',
    rating: 5,
    text: 'As a first-time renter in London, I was nervous about the process. MyAbode\'s platform was so clear and the saved listings feature helped me compare properties easily. Found my perfect Kensington townhouse!',
    property: 'Charming Townhouse in Kensington',
    date: 'January 2026',
    location: 'London, UK',
  },
  {
    id: '4',
    reviewer: 'Robert Chen',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Asian%20man%20headshot%2C%20friendly%20expression%2C%20smart%20casual%2C%20neutral%20background%2C%2035s&width=80&height=80&seq=rev4&orientation=squarish',
    rating: 4,
    text: 'Excellent platform with a beautiful interface. The filter system is powerful and the property photos are stunning. The agent response time could be slightly faster, but overall a fantastic experience.',
    property: 'Beachfront Apartment in Miami',
    date: 'March 2026',
    location: 'Miami, FL',
  },
  {
    id: '5',
    reviewer: 'Isabella Torres',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Latina%20woman%20headshot%2C%20warm%20smile%2C%20elegant%20style%2C%20soft%20background&width=80&height=80&seq=rev5&orientation=squarish',
    rating: 5,
    text: 'The personalized dashboard is a game-changer. Being able to track all my saved properties, upcoming viewings, and search history in one place made the whole home-buying journey so much less stressful.',
    property: 'Hillside Retreat with Valley Views',
    date: 'February 2026',
    location: 'Malibu, CA',
  },
];
